import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SharingLink from './SharingLink';
import { setAbout, setLoadingScreen } from '../store/ui';

const FooterElement = styled.footer`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: white;
  padding-left: 75px;

  display: flex;
  align-items: center;
  justify-content: start;
  pointer-events: none;

  @media only screen and (max-width: 600px) {
    padding-left: 0;
  }

  > * + * {
    border-left: 1px solid rgba(255,255,255,0.66);
  }
`;

const SharingDialog = styled.div`
  @keyframes open-dialog {
    0% { transform: scaleY(0); }
    100% { transform: scaleY(1); }
  }

  padding: 20px 20px 10px;
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: none;
  animation: open-dialog 150ms ease-in-out forwards;
  transform-origin: left bottom;
  flex-direction: row;
  justify-content: space-between;
`;

const Button = styled.a`
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  pointer-events: auto;
  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.8), 0px 1px 10px rgba(0, 0, 0, 0.4);

  color: white;

  margin: 0;
  padding: 4px 15px;

  border-radius: none;
  text-decoration: none;

  &:hover {
    text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.8),
      0px 1px 10px rgba(0, 0, 0, 0.4);
    background-color: rgba(0, 0, 0, 0.8);
  }

  @media only screen and (max-width: 600px) {
    font-size: 12px;
    margin: 0 0 30px 0;
    padding: 4px 10px;
    line-height: 1;
    &:first-child {
      padding-left: 10px;
    }
  }
`;

const SharingContainer = styled.div`
  @media only screen and (max-width: 600px) {
    display: none;
  }

  position: relative;

  ${({ isDialogOpen }) => (isDialogOpen ? `
    width: 180px;

    ${SharingDialog} {
      display: flex;
    }

    ${Button} {
      text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.8),
        0px 1px 10px rgba(0, 0, 0, 0.4);
      background-color: rgba(0, 0, 0, 0.8);
    }
  ` : ``)}

  ${Button} {
    display: block;
  }
`;

/**
 * Footer element
 */
class Footer extends React.PureComponent {
  static propTypes = {
    showAbout: PropTypes.func.isRequired,
    showIntro: PropTypes.func.isRequired,
  };

  /**
   * @param {!props} props properties of the class.
   */
  constructor(props) {
    super(props);

    this.state = { showSharingDialog: false };

    this.toggleSharingDialog = this.toggleSharingDialog.bind(this);
  }

  /**
   * Toggle sharing dialog
   */
  toggleSharingDialog() {
    const { showSharingDialog } = this.state;
    this.setState({ showSharingDialog: !showSharingDialog });
  }

  /**
   * React lifecycle method
   * @param {*} object
   * @return {JSX}
   */
  render() {
    const {
      showIntro,
      showAbout,
    } = this.props;

    const { showSharingDialog } = this.state;

    return (
      <FooterElement>
        <Button
          id="show-intro"
          aria-label="Returns to the introduction page"
          onClick={showIntro}
        >
          Back to intro
        </Button>
        <Button
          id="show-about-text"
          aria-label="Show about text"
          onClick={showAbout}
        >
          About
        </Button>
        <SharingContainer isDialogOpen={showSharingDialog}>
          <Button
            id="show-share-dialog"
            aria-label="Show sharing dialog"
            onClick={this.toggleSharingDialog}
          >
            Share
          </Button>

          <SharingDialog>
            <SharingLink type="facebook" />
            <SharingLink type="twitter" />
            <SharingLink type="linkedin" />
          </SharingDialog>
        </SharingContainer>
      </FooterElement>
    );
  }
}

export default connect(
    null,
    (dispatch) => ({
      showAbout: () => dispatch(setAbout(true)),
      showIntro: () => dispatch(setLoadingScreen(true)),
    }),
)(Footer);
